export enum RemunerationDrilldownType {
    Range = 1,
    Median = 2,
    Remuneration = 3
}